import React, { ReactNode, createContext, useCallback, useContext, useMemo } from 'react'

import { FormikTouched, useFormikContext } from 'formik'

import { Form } from '../../../ana-toolbox'

const Context = createContext({})

/* This provider gets some functions from formik context
 * memoize, and provide them. It's built to fix some performance issues
 * due to the high amount of Formik updates.
 */
export const FormHelpersProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const { touched, setErrors, setFieldValue, setFieldTouched, getFieldProps, setValues, setTouched } =
    useFormikContext()

  const customSetTouched = useCallback(
    (newValues: FormikTouched<Partial<Form>>) => {
      setTouched({
        ...touched,
        ...newValues,
      })
    },
    [touched, setTouched]
  )

  const value = useMemo(
    () => ({
      setFieldValue,
      setFieldTouched,
      getFieldProps,
      setValues,
      setErrors,
      setTouched: customSetTouched,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFieldValue, setFieldTouched, getFieldProps, setValues, customSetTouched]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useFormHelpers = () => {
  const context = useContext(Context)

  return context
}
